import { createFileRoute, redirect } from '@tanstack/react-router';

// 認証ポリシー / 旧インバウンドSSO設定はそれぞれ新 URL へ寄せる。
export const Route = createFileRoute('/_staff/settings/persons/_list/settings/')({
  beforeLoad: ({
    location
  }) => {
    const hash = location.hash.replace(/^#/, '');
    if (hash === 'sso') {
      throw redirect({
        to: '/settings/authentication/settings/sso'
      });
    }
    throw redirect({
      to: '/settings/authentication/settings/authentication-method'
    });
  }
});